import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { DropDownComponentBase } from './drop-down.base.component';

import { StoreService } from '../../_services';
import { IStoreFormat } from '../../_entities';

@Component({
    selector: 'store-format-dropdown',
    template: require('./dropdown.template.html'),
    styles: ['input[type=text] { margin-top:10px; }']
})
export class StoreFormatDropDownComponent extends DropDownComponentBase<IStoreFormat> {
    constructor(private storeService: StoreService) {
        super();
    }

    getItems(): Promise<IStoreFormat[]> {
        return this.storeService.getStoreFormats();
    }
    mapItem(items: IStoreFormat[], item: IStoreFormat): IStoreFormat {
        return (<IStoreFormat[]>items).find(x => x.name === item.name);
    }
    onItemSelected(item: IStoreFormat) {
        this.selectedItemChange.emit(item);
    }

    @Input("selectedFormat") set selectedBinding(val: IStoreFormat) {
        if (val != this.selectedItem)
            this.setSelectedItem(val);
    }
    @Output("selectedFormatChange") selectedItemChange = new EventEmitter<IStoreFormat>();
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/store-format-dropdown.component.ts